// shared/utils/policyComplianceStatsCalculator.js - Policy Compliance 통계 계산 공통 함수
/**
 * 모든 페이지에서 일관성 있게 사용할 Policy Compliance 통계 계산 함수
 */

/**
 * Policy Compliance 통계 계산
 * @param {Array} usersWithCompliance - Policy Compliance가 계산된 사용자 배열
 * @returns {Object} Policy Compliance 통계
 */
export const calculatePolicyComplianceStats = (usersWithCompliance) => {
  // 고용중인 사용자만 계산 대상
  const employedUsers = usersWithCompliance.filter(user => user.status === 'employed');
  
  const stats = {
    total: employedUsers.length,
    compliant: employedUsers.filter(user => user.compliance >= 100).length,
    nonCompliant: employedUsers.filter(user => user.compliance < 100).length,
    noData: usersWithCompliance.filter(user => user.status === 'no_employment_data').length,
    averageCompliance: employedUsers.length > 0 ? 
      Math.round(employedUsers.reduce((sum, user) => sum + user.compliance, 0) / employedUsers.length) : 0
  };
  
  console.log('📊 Policy Compliance 통계 계산:', {
    allUsers: usersWithCompliance.length,
    employedUsers: employedUsers.length,
    compliant: stats.compliant,
    nonCompliant: stats.nonCompliant,
    averageCompliance: stats.averageCompliance,
    employedUsersDetails: employedUsers.map(u => ({
      email: u.email,
      compliance: u.compliance,
      totalRemittance: u.totalRemittance,
      monthlyAverage: u.monthlyAverage
    }))
  });
  
  return stats;
};

/**
 * 사용자별 Policy Compliance 계산 (공통 로직)
 * @param {Array} userList - 사용자 목록
 * @param {Function} calculatePolicyCompliance - Policy Compliance 계산 함수
 * @param {Object} firebaseUtils - Firebase 유틸리티
 * @param {string} appId - 앱 ID
 * @returns {Promise<Array>} Policy Compliance가 계산된 사용자 배열
 */
export const calculateUsersWithCompliance = async (userList, calculatePolicyCompliance, firebaseUtils, appId) => {
  console.log('🔧 Policy Compliance 계산 시작:', userList.length, '명');
  
  const usersWithCompliance = await Promise.all(
    userList.map(async (user) => {
      try {
        const complianceInfo = await calculatePolicyCompliance(user.id, appId, firebaseUtils);
        
        console.log(`📊 사용자 ${user.email} Policy Compliance:`, {
          status: complianceInfo.status,
          compliance: complianceInfo.compliance,
          companyName: complianceInfo.companyName
        });
        
        return {
          ...user,
          status: complianceInfo.status,
          compliance: complianceInfo.compliance,
          companyName: complianceInfo.companyName,
          monthlyAverage: complianceInfo.monthlyAverage || 0,
          totalRemittance: complianceInfo.totalRemittance || 0,
          monthsEmployed: complianceInfo.monthsEmployed || 0
        };
      } catch (error) {
        console.error(`사용자 ${user.id}의 Policy Compliance 계산 오류:`, error);
        return {
          ...user,
          status: 'no_employment_data',
          compliance: 0,
          companyName: '',
          monthlyAverage: 0,
          totalRemittance: 0,
          monthsEmployed: 0
        };
      }
    })
  );
  
  console.log(`✅ Policy Compliance 계산 완료: ${usersWithCompliance.length}명`);
  return usersWithCompliance;
};
